export default "__VITE_ASSET__P9NclkEx__"